import { render } from "./Page8.vue?vue&type=template&id=6d48d390&scoped=true"
import script from "./Page8.vue?vue&type=script&lang=js"
export * from "./Page8.vue?vue&type=script&lang=js"

import "./Page8.vue?vue&type=style&index=0&id=6d48d390&lang=css"
import "./Page8.vue?vue&type=style&index=1&id=6d48d390&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d48d390"]])

export default __exports__